export const apiPath = '/v2/company/notification_preference';
const actionType = 'NOTIFICATION_PREFERENCE';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
